import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { Link, useTheme, Text } from '@retailer-platform/shared-components/src/tds'
import { ArrowRightIcon } from '@instacart/ids-core'

type OnboardingSiteSetupChecklistStepProps = {
  stepIndex: number
  text: string
  complete?: boolean
  href?: string
  dataTestId?: string
  openNewTab?: boolean
}

export const OnboardingSiteSetupChecklistStep: FunctionComponent<
  OnboardingSiteSetupChecklistStepProps
> = ({ stepIndex, text, href, dataTestId, openNewTab = false }) => {
  const theme = useTheme()

  const LinkWrapper = styled.div({
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
  })

  const IndexBox = styled.div({
    width: '16px',
    height: '16px',
    backgroundColor: theme.colors.systemGrayscale20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.systemGrayscale60,
    marginRight: '5px',
    flex: '0 0 auto',
    boxSizing: 'border-box',
  })

  // TODO: display complete state

  return (
    <LinkWrapper data-testid={dataTestId}>
      <IndexBox>
        <Text typography={'accentEmphasized'}>{stepIndex}</Text>
      </IndexBox>
      <Link
        rightIcon={ArrowRightIcon}
        href={href}
        target={openNewTab ? '_blank' : undefined}
        rel={openNewTab ? 'noopener noreferrer' : undefined}
      >
        {text}
      </Link>
    </LinkWrapper>
  )
}
